import store from '@/store'
import Cookies from 'js-cookie'

/**
 * 权限
 * @param {*} key
 */
export function hasPermission (key) {
  return window.SITE_CONFIG['permissions'].indexOf(key) !== -1 || false
}

/**
 * 获取字典数据列表
 * @param dictType  字典类型
 */
export function getDictDataList (dictType) {
  const type = window.SITE_CONFIG['dictList'].find((element) => (element.dictType === dictType))
  if (type) {
    return type.dataList
  } else {
    return []
  }
}

/**
 * 获取字典名称
 * @param dictType  字典类型
 * @param dictValue  字典值
 */
export function getDictLabel (dictType, dictValue) {
  const type = window.SITE_CONFIG['dictList'].find((element) => (element.dictType === dictType))
  if (type) {
    const val = type.dataList.find((element) => (element.dictValue === dictValue + ''))
    if (val) {
      return val.dictLabel
    } else {
      return dictValue
    }
  } else {
    return dictValue
  }
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  store.commit('resetStore')
  Cookies.remove('token')
  window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = false
}

/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (getSecureRandom() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

// 生成安全随机数
function getSecureRandom() {
  const array = new Uint32Array(1)
  window.crypto.getRandomValues(array)
  return array[0] / 4294967295 // 转换为0-1之间的数
}
/**
 * 获取svg图标(id)列表
 */
export function getIconList () {
  var res = []
  var list = document.querySelectorAll('svg symbol')
  for (var i = 0; i < list.length; i++) {
    res.push(list[i].id)
  }

  return res
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'pid') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (!temp[data[k][pid]] || data[k][id] === data[k][pid]) {
      res.push(data[k])
      continue
    }
    if (!temp[data[k][pid]]['children']) {
      temp[data[k][pid]]['children'] = []
    }
    temp[data[k][pid]]['children'].push(data[k])
    data[k]['_level'] = (temp[data[k][pid]]._level || 0) + 1
  }
  return res
}

/**
 * 根据语言获取路由地址
 */
 export function getRouterPath (language) {
  console.log("getRouterPath",language);
  var path="";
  if(language == 'en') {
    path = 'login-EN';
  } else if (language == 'zh-CN'){
    path = 'login-CN';
  }

  return path;
}

/**
 * Function to remove the OSS info that is appended to the URL of an image uploaded to OSS
 * @param {*} giftImgUrl
 * @returns string of the image URL
 */
export function getOriginalImgUrl(giftImgUrl) {
  if (!giftImgUrl || giftImgUrl.length === 0) {
    return '';
  }

  const index = giftImgUrl.indexOf('?Expires=');
  if (index === -1) {
    return giftImgUrl;
  } else {
    return giftImgUrl.substring(0, index);
  }
}

/**
 * Function to format time string from: 2021-09-01T00:00:00.000Z to: 2021-09-01 00:00:00
 * @param {*} timeStr
 * @returns formatted time string
 */
export function formatStrWithTimezone(timeStr) {
  if (timeStr) {
    const date = new Date(timeStr);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
    const second = date.getSeconds().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    return formattedDate
  } else {
    return timeStr
  }
}